import { createSlice } from "@reduxjs/toolkit";
import Toast from "../../helpers/Toast";
import * as actions from "../action/sales";
import {
  getOrderListResponse,
  memberRankingResponse,
  orderDetailsResponse,
  payloadCartResponse,
  payloadOrderList,
} from "../../types/sales";
import { addRegisterSales, getMemberRakingList } from "../action/sales";

type InitialState = {
  cartList: payloadCartResponse[];
  memberRegisterList: memberRankingResponse[];
  orderList: getOrderListResponse[];
  orderDetails: orderDetailsResponse;
};

const initialState: InitialState = {
  cartList: [],
  memberRegisterList: [],
  orderList: [],
  orderDetails: {} as orderDetailsResponse,
};

const salesSlice = createSlice({
  name: "sales",
  initialState: initialState,
  reducers: {
    resetSales: () => initialState,
  },

  extraReducers(builder) {
    builder
      .addCase(actions.addToCart.fulfilled, (state, action) => {
        Toast.fire({
          icon: "success",
          title: "Added to cart",
        });
      })
      .addCase(actions.addToCart.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail added to cart",
        });
      })

      .addCase(actions.getCartList.fulfilled, (state, action) => {
        state.cartList = action.payload;
      })
      .addCase(actions.getCartList.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail get cart list",
        });
      })

      .addCase(actions.updateCartProductQuantity.fulfilled, (state, action) => {
        Toast.fire({
          icon: "success",
          title: "Added to cart",
        });
      })
      .addCase(actions.updateCartProductQuantity.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail added to cart",
        });
      })

      .addCase(actions.addRepeatSales.fulfilled, (state, action) => {
        Toast.fire({
          icon: "success",
          title: "Order Success",
        });
      })
      .addCase(actions.addRepeatSales.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Order Failed",
        });
      })

      .addCase(actions.getMemberRakingList.fulfilled, (state, action) => {
        state.memberRegisterList = action.payload;
      })
      .addCase(actions.getMemberRakingList.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Failed Get Member Ranking",
        });
      })

      .addCase(actions.addRegisterSales.fulfilled, (state, action) => {})
      .addCase(actions.addRegisterSales.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Order Failed",
        });
      })
      .addCase(actions.getOrderList.fulfilled, (state, action) => {
        state.orderList = action.payload;
      })
      .addCase(actions.getOrderList.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Failed Get Order List",
        });
      })

      .addCase(actions.getOrderDetails.fulfilled, (state, action) => {
        state.orderDetails = action.payload;
      })
      .addCase(actions.getOrderDetails.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Failed Get Order List",
        });
      });
  },
});

export const {} = salesSlice.actions;
export default salesSlice.reducer;
